export function getIsMinCreditLimitExpired(isMinCreditLimitExpired?: boolean) {
    if (
        isMinCreditLimitExpired === true ||
        isMinCreditLimitExpired === undefined
    ) {
        return true
    }
    return false
}
